export default __webpack_public_path__ + "static/media/BS_outline.8bd29b41.png";